module.exports = "/_next/static/images/mailSent-ec878397175ee38a75639d0d7d9e9bdd.svg";